function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.0339 15.4576C0.910605 15.4576 0 16.0979 0 16.8877V25.1822H0.00168829C0.000564834 25.2298 0 25.2774 0 25.3252C0 29.9851 5.37258 33.7627 12 33.7627C18.6274 33.7627 24 29.9851 24 25.3252C24 25.2774 23.9994 25.2298 23.9983 25.1822H24V16.8877C24 16.0979 23.0894 15.4576 21.9661 15.4576H2.0339Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 0C1.34315 0 0 1.34315 0 3V11.2373C0 12.8941 1.34315 14.2373 3 14.2373H8.38983C10.0467 14.2373 11.3898 12.8941 11.3898 11.2373V11.2206C10.6715 10.9067 10.1695 10.19 10.1695 9.35593V4.47457C10.1695 3.64978 10.6604 2.93965 11.3661 2.62049C11.1795 1.14281 9.91813 0 8.38983 0H3Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.0406 2.62044C13.7463 2.93959 14.2373 3.64974 14.2373 4.47458V9.35593C14.2373 10.19 13.7352 10.9068 13.0168 11.2206V11.2373C13.0168 12.8941 14.36 14.2373 16.0168 14.2373H20.9999C22.6568 14.2373 23.9999 12.8941 23.9999 11.2373V3C23.9999 1.34315 22.6568 0 20.9999 0H16.0168C14.4886 0 13.2272 1.14278 13.0406 2.62044Z",
  fill: "#C4C4C4"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5762,
  y: 2.84746,
  width: 3.25424,
  height: 8.13559,
  rx: 1.62712,
  fill: "white"
});

const SvgRight = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/right.24b78a25.svg";
export { ForwardRef as ReactComponent };